import { ProtectRule } from '../../components/protect-rules'
import { Cve } from '../../components/cve-shields/shared'

export function setExpandWithSkipLinks(expand: string | undefined) {
  const expandList = expand ? expand.split(',') : []
  return Array.from(new Set(['skip_links', ...expandList])).join(',')
}

export function normalizeProtectRule({
  development,
  qa,
  production,
  can_block_at_perimeter,
  is_monitor_at_perimeter,
  parent_rule_uuid,
  parent_rule_name,
  ruleId,
  name,
  uuid,
  description,
  languages,
  cves,
  can_block
}): ProtectRule {
  return {
    ruleId,
    name,
    uuid,
    description,
    languages,
    canBlockAtPerimeter: can_block_at_perimeter,
    isMonitorAtPerimeter: is_monitor_at_perimeter,
    parentRuleUuid: parent_rule_uuid,
    parentRuleName: parent_rule_name,
    development: { protectMode: development.protect_mode },
    qa: { protectMode: qa.protect_mode },
    production: { protectMode: production.protect_mode },
    cves: Array.isArray(cves) ? cves.map(normalizeCve) : cves,
    canBlock: can_block
  }
}

function normalizeCve({
  accessComplexity,
  accessVector,
  authentication,
  availabilityImpact,
  confidentialityImpact,
  description,
  integrityImpact,
  name,
  references,
  score,
  status,
  uuid
}): Cve {
  return {
    accessComplexity,
    accessVector,
    authentication,
    availabilityImpact,
    confidentialityImpact,
    description,
    integrityImpact,
    name,
    references,
    score,
    status,
    uuid
  }
}
